import { useCallback, useMemo, useState } from 'react';

type Option = {
  value: string | number;
  label: string;
};

export const usePrefectureSearch = (prefectureOptions: Option[]) => {
  const [searchValue, setSearchValue] = useState('');

  const handleSearch = useCallback((value: string) => {
    setSearchValue(value);
  }, []);

  const filteredOptions = useMemo(() => {
    if (!searchValue) return prefectureOptions;

    return prefectureOptions.filter((option) => {
      const label = option?.label;
      if (typeof label === 'string') {
        return label.toLowerCase().includes(searchValue.toLowerCase());
      }
      return false;
    });
  }, [prefectureOptions, searchValue]);

  return { filteredOptions, handleSearch };
};
